import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, CheckCircle2, Globe2 } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import axios from 'axios';
import { useSiteContent } from '../contexts/SiteContentContext';

const API = process.env.REACT_APP_BACKEND_URL;
const B = `${API}/api/files/dersimizcografiya/uploads`;

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const content = useSiteContent();
  

  useEffect(() => {
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true); setError('');
    try { await axios.post(`${API}/api/contact`, form); setSent(true); setForm({ name: '', email: '', subject: '', message: '' }); }
    catch { setError('Mesaj göndərilə bilmədi. Yenidən cəhd edin.'); }
    finally { setSending(false); }
  };

  if (!content) return <div className="min-h-screen flex items-center justify-center bg-[#F4F7F6]"><div className="w-10 h-10 border-4 border-[#0077B6] border-t-transparent rounded-full animate-spin" /></div>;

  const pg = content.contact_page || {};
  const heroBadge = pg.hero_badge || 'Əlaqə';
  const heroTitle = pg.hero_title || 'Bizimlə Əlaqə';
  const heroSubtitle = pg.hero_subtitle || 'Suallarınız üçün bizimlə əlaqə saxlayın';
  const heroBg = pg.hero_bg || `${B}/6c1e8512-f1b6-40d6-8b84-3c9e14379c1a.jpg`;
  const infoTitle = pg.info_title || 'Əlaqə Məlumatları';
  const email = pg.email || 'info@dersimizcografiya.az';
  const phone = pg.phone || '+994 50 XXX XX XX';
  const address = pg.address || 'Bakı, Azərbaycan';
  const addressMapUrl = pg.address_map_url || '';
  const extraContacts = pg.extra_contacts || [];
  const formTitle = pg.form_title || 'Mesaj Göndər';
  const formFields = pg.form_fields || { name_label: 'Adınız', email_label: 'E-poçt', subject_label: 'Mövzu', message_label: 'Mesaj', button_text: 'Göndər', success_title: 'Göndərildi!', success_text: 'Mesajınız uğurla göndərildi. Tezliklə cavab verəcəyik.' };
  const mapEmbed = pg.map_embed || 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194473.3015722868!2d49.69940799999999!3d40.394528549999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d6bd6211cf9%3A0x343f6b5e7ae56c6b!2zQmFrxLEsIEF6yZlyYmF5Y2Fu!5e0!3m2!1sen!2s!4v1715000000000!5m2!1sen!2s';

  return (
    <div>
      {/* Hero */}
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img src={heroBg} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#03045E]/40 to-transparent" />
        </div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-white text-sm font-bold mb-4 border border-white/20">
              <Globe2 className="w-4 h-4" /> {heroBadge}
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mt-4">{heroTitle}</h1>
            <p className="text-white font-semibold text-base md:text-lg max-w-2xl mx-auto mt-6">{heroSubtitle}</p>
          </motion.div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-16 md:py-24 bg-[#F4F7F6]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            {/* Info */}
            <motion.div className="lg:col-span-2" initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1A2530] mb-6">{infoTitle}</h2>
              <div className="space-y-6">
                <a href={`mailto:${email}`} className="flex items-center gap-4 group">
                  <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 flex items-center justify-center group-hover:bg-[#0077B6] transition-colors duration-300">
                    <Mail className="w-5 h-5 text-[#0077B6] group-hover:text-white transition-colors" />
                  </div>
                  <div><div className="text-xs text-[#5C6B7A]">E-poçt</div><div className="font-semibold text-[#1A2530]">{email}</div></div>
                </a>
                <a href={`tel:${phone.replace(/\s/g,'')}`} className="flex items-center gap-4 group">
                  <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 flex items-center justify-center group-hover:bg-[#0077B6] transition-colors duration-300">
                    <Phone className="w-5 h-5 text-[#0077B6] group-hover:text-white transition-colors" />
                  </div>
                  <div><div className="text-xs text-[#5C6B7A]">Telefon</div><div className="font-semibold text-[#1A2530]">{phone}</div></div>
                </a>
                {addressMapUrl ? (
                <a href={addressMapUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 group">
                  <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 flex items-center justify-center group-hover:bg-[#0077B6] transition-colors duration-300">
                    <MapPin className="w-5 h-5 text-[#0077B6] group-hover:text-white transition-colors" />
                  </div>
                  <div><div className="text-xs text-[#5C6B7A]">Ünvan</div><div className="font-semibold text-[#1A2530] group-hover:text-[#0077B6] transition-colors">{address}</div></div>
                </a>
                ) : (
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-[#0077B6]" />
                  </div>
                  <div><div className="text-xs text-[#5C6B7A]">Ünvan</div><div className="font-semibold text-[#1A2530]">{address}</div></div>
                </div>
                )}
                {extraContacts.map((ec, i) => {
                  const Icon = ec.type === 'email' ? Mail : ec.type === 'phone' ? Phone : MapPin;
                  if (ec.type === 'address') return (
                    <div key={i} className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 flex items-center justify-center"><Icon className="w-5 h-5 text-[#0077B6]" /></div>
                      <div><div className="text-xs text-[#5C6B7A]">{ec.label || 'Ünvan'}</div><div className="font-semibold text-[#1A2530]">{ec.value}</div></div>
                    </div>
                  );
                  return (
                    <a key={i} href={ec.type === 'email' ? `mailto:${ec.value}` : `tel:${ec.value.replace(/\s/g,'')}`} className="flex items-center gap-4 group">
                      <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 flex items-center justify-center group-hover:bg-[#0077B6] transition-colors duration-300"><Icon className="w-5 h-5 text-[#0077B6] group-hover:text-white transition-colors" /></div>
                      <div><div className="text-xs text-[#5C6B7A]">{ec.label || (ec.type === 'email' ? 'E-poçt' : 'Telefon')}</div><div className="font-semibold text-[#1A2530]">{ec.value}</div></div>
                    </a>
                  );
                })}
              </div>
            </motion.div>

            {/* Form */}
            <motion.div className="lg:col-span-3" initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              {sent ? (
                <div className="bg-white rounded-2xl p-12 border border-[#E2E8F0] text-center" data-testid="contact-success">
                  <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
                  <h3 className="text-2xl font-bold text-[#1A2530] mb-2">{formFields.success_title || 'Göndərildi!'}</h3>
                  <p className="text-[#5C6B7A]">{formFields.success_text || 'Mesajınız uğurla göndərildi.'}</p>
                  <Button data-testid="contact-new-message" onClick={() => setSent(false)} className="mt-6 bg-[#0077B6] hover:bg-[#005f92]">Yeni Mesaj</Button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 border border-[#E2E8F0]" data-testid="contact-form">
                  <h3 className="text-2xl font-bold text-[#1A2530] mb-6">{formTitle}</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div><label className="text-sm text-[#5C6B7A] mb-1 block">{formFields.name_label || 'Adınız'}</label>
                      <Input data-testid="contact-name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder={formFields.name_label || 'Adınız'} /></div>
                    <div><label className="text-sm text-[#5C6B7A] mb-1 block">{formFields.email_label || 'E-poçt'}</label>
                      <Input data-testid="contact-email" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required placeholder="email@example.com" /></div>
                  </div>
                  <div className="mb-4"><label className="text-sm text-[#5C6B7A] mb-1 block">{formFields.subject_label || 'Mövzu'}</label>
                    <Input data-testid="contact-subject" value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} required placeholder={formFields.subject_label || 'Mövzu'} /></div>
                  <div className="mb-6"><label className="text-sm text-[#5C6B7A] mb-1 block">{formFields.message_label || 'Mesaj'}</label>
                    <Textarea data-testid="contact-message" value={form.message} onChange={e => setForm({...form, message: e.target.value})} required rows={5} placeholder="Mesajınızı yazın..." /></div>
                  {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
                  <Button data-testid="contact-submit" type="submit" disabled={sending} className="w-full bg-[#0077B6] hover:bg-[#005f92] text-sm py-3 h-auto">
                    {sending ? 'Göndərilir...' : <><Send className="w-4 h-4 mr-2" /> {formFields.button_text || 'Göndər'}</>}
                  </Button>
                </form>
              )}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Map */}
      {mapEmbed && (
        <section className="bg-white">
          <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
            <h2 className="text-3xl font-bold text-[#1A2530] mb-6 flex items-center gap-3">
              <MapPin className="w-7 h-7 text-[#0077B6]" /> Xəritədə Yerimiz
            </h2>
            <div className="rounded-3xl overflow-hidden shadow-lg border border-[#E2E8F0]">
              <iframe src={mapEmbed} width="100%" height="450" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Xəritə" />
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
